// extracted by mini-css-extract-plugin
module.exports = {"tab_h":"kishalaya_tab_h__Q0wbr","table":"kishalaya_table__Xvlyg","w_50":"kishalaya_w_50__9z9Xj"};